import {gql} from '@apollo/client/core';


export const ProductAllMetaFragment = gql`
  fragment productAllMeta on WineMeta {
    id
    units {
      shortName
    }
    ratings {
      id
      label
      rating
      name
      starCount
      review
      isPreviousVintage
      reviewSnippet
    }
    foods {
      id
      label
      icon
      path
      pdfIcon
    }
    grapesV2 {
      id
      title
      urlPath
    }
    barrelTypes {
      id
      title
      urlPath
    }
    countryEnt {
      id
      title
      icon
      urlPath
    }
    areaEnt {
      id
      title
      urlPath
    }
    districtEnt {
      id
      title
      urlPath
    }
    powerLabel
    powerValue
    sweetnessLabel
    sweetnessValue
    wineBodyLabel
    wineBodyValue
    tastingNotes {
      id
      title
      icon
      path
    }
    nutritionalInfoUrl
    allergens
    savingPotential
    alcohol
    contents
    contentLabel
    serving
    producer {
      id
      title
      urlPath
      contentImage
      description
    }
    wineType
    productType
    productSubType
    vintage
    portType
    energyLabel
    energyLabelDoc
    productDataSheet
    acidContent
    residualSugar
    measurementUnit
  }
`;
